import { api } from './api';

export type PageViewPayload = {
  ttp: string;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class TiktokCAPI {
  static get BASE_PATH() {
    if (import.meta.client) {
      return [globalThis?.location?.origin || '', 'api/'].join('/');
    }

    return '';
  }

  static async send(payload: PageViewPayload, headers?: Record<string, any>) {
    const response = await api.post(`${TiktokCAPI.BASE_PATH}tiktokCapi`, payload, headers);
    return response.data;
  }
}
